var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedInIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 41,
    viewBox: "0 0 28 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2693_651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 40.4C18.528 33.48 27.784 20.232 27.952 13.968C27.944 6.248 21.68 0 13.968 0C6.256 0 0 6.256 0 13.968C0.168 20.248 9.472 33.472 14 40.4ZM5.976 13.968C6.424 3.352 21.528 3.36 21.976 13.968C21.976 18.384 18.384 21.968 13.968 21.96C9.56 21.96 5.984 18.384 5.976 13.968Z",
    fill: "#DA0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3742 13.9681C20.0542 5.48808 7.89422 5.49608 7.57422 13.9681C7.89422 22.4481 20.0542 22.4481 20.3742 13.9681ZM12.1182 16.9841L9.80622 14.6721C9.50222 14.3521 9.51022 13.8481 9.83022 13.5441C10.1422 13.2481 10.6302 13.2481 10.9422 13.5441L12.6782 15.2881L17.0062 10.9601C17.3262 10.6561 17.8302 10.6641 18.1422 10.9761C18.4382 11.2881 18.4382 11.7761 18.1422 12.0881L13.2462 16.9841C12.9342 17.2961 12.4302 17.2961 12.1182 16.9841Z",
    fill: "#DA0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2693_651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 40.8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedInIcon);
export default __webpack_public_path__ + "static/media/checkedInIcon.9d97b23fe0ab021091aad7325d9ca19a.svg";
export { ForwardRef as ReactComponent };